export const NotFoundConfig = () => {
  return <span>This element type is not supported, please try again</span>
}
